export default defineNuxtPlugin((nuxtApp) => {
    const { fetchCurrencyConfig } = useCurrency()
    
    // Fetch currency config on app mount
    nuxtApp.hook('app:mounted', () => {
        console.log('[Plugin] App mounted, fetching currency config...')
        fetchCurrencyConfig()
    })
})
